/*
 * @Descripttion:
 * @Author: sjq
 * @Date: 2020-02-29 08:39:18
 * @LastEditors: sjq
 * @LastEditTime: 2020-02-29 16:56:25
 */

export const loadmore = {
  inserted(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTDOWN_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTDOWN_DOM.addEventListener('scroll', function () {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
      if (CONDITION) {
        binding.value()
      }
    })
  }
}
